import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import React, { useState } from "react";
import {
  Col,
  Form,
  Row,
  Table,
  Image,
  Modal,
  Button,
  Container,
} from "react-bootstrap";
import Alert from "react-s-alert";
import Media from "react-media";
import { NewInputText } from "../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { BottomNavigationMobile } from "../navigationSection/BottomNavigationMobile";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { vendor_create_role } from "../../../store/actions/vendorRoleManagement/vendorRoleManagement";
import { clear_all_errors } from "../../../store/actions/errorActions";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";

const staffManagementData = [
  {
    name: "Staff Management",
    data: [
      { name: "Staff User Create", checked: false },
      { name: "Staff User Edit", checked: false },
      { name: "Staff User View", checked: false },
      { name: "Staff User Delete", checked: false },
      { name: "Staff User Block", checked: false },
      { name: "Staff User Reset Password", checked: false },
      { name: "Staff User Flag", checked: false },
    ],
  },
  {
    name: "Offer Management",
    data: [
      { name: "Add Offline Offer", checked: false },
      { name: "Edit Offline Offer", checked: false },
      { name: "Delete Offline Offer", checked: false },
      { name: "View Offline Offer", checked: false },
      { name: "Active Offline Event", checked: false },
      { name: "Inactive Offline Event", checked: false },
      { name: "Add Online Offer", checked: false },
      { name: "Edit Online Offer", checked: false },
      { name: "Delete Online Offer", checked: false },
      { name: "View Online Offer", checked: false },
      { name: "Active Online Event", checked: false },
      { name: "Inactive Online Event", checked: false },
    ],
  },
  {
    name: "Event Management",
    data: [
      { name: "Add Offline Event", checked: false },
      { name: "Edit Offline Event", checked: false },
      { name: "Delete Offline Event", checked: false },
      { name: "View Offline Event", checked: false },
      { name: "Active Offline Event", checked: false },
      { name: "Inactive Offline Event", checked: false },
      { name: "View Offline Event Dashboard", checked: false },
      { name: "Add Online Event", checked: false },
      { name: "Edit Online Event", checked: false },
      { name: "Delete Online Event", checked: false },
      { name: "View Online Event", checked: false },
      { name: "Active Online Event", checked: false },
      { name: "Inactive Online Event", checked: false },
      { name: "View Online Event Dashboard", checked: false },
      { name: "Assign Seating Area", checked: false },
    ],
  },
  {
    name: "Order Types",
    data: [
      { name: "View Pending Orders", checked: false },
      { name: "Add Pending Orders", checked: false },
      { name: "Edit Pending Orders", checked: false },
      { name: "Change Pending Order Status", checked: false },
      { name: "Cancel Order", checked: false },
      { name: "Cancel Item", checked: false },
      { name: "Substitute Item", checked: false },
      { name: "Refund Item", checked: false },
      { name: "View All Orders", checked: false },
      { name: "Add All Orders", checked: false },
      { name: "Edit All Orders", checked: false },
      { name: "Change All Order Status", checked: false },
      { name: "View Takeaway Orders", checked: false },
      { name: "Edit Takeaway Orders", checked: false },
      { name: "Change Takeaway Order Status", checked: false },
      { name: "Cancel Order Takeaway", checked: false },
      { name: "Cancel Item Takeaway", checked: false },
      { name: "Substitute Item Takeaway", checked: false },
      { name: "Refund Item Takeaway", checked: false },
      { name: "View Curbside Orders", checked: false },
      { name: "Add Curbside Orders", checked: false },
      { name: "Edit Curbside Orders", checked: false },
      { name: "Change Curbside Order Status", checked: false },
      { name: "Cancel Order Curbside", checked: false },
      { name: "Cancel Item Curbside", checked: false },
      { name: "Substitute Item Curbside", checked: false },
      { name: "Refund Item Curbside", checked: false },
      { name: "View Skip the Line Orders", checked: false },
      { name: "Add Skip the Line Orders", checked: false },
      { name: "Edit Skip the Line Orders", checked: false },
      { name: "Change Skip the Line Order Status", checked: false },
      { name: "Cancel Order Skip the Line", checked: false },
      { name: "Cancel Item Skip the Line", checked: false },
      { name: "Substitute Item Skip the Line", checked: false },
      { name: "Refund Item Skip the Line", checked: false },
      { name: "View Dine In Orders", checked: false },
      { name: "Add Dine In Orders", checked: false },
      { name: "Edit Dine In Orders", checked: false },
      { name: "Change Dine In Order Status", checked: false },
      { name: "Cancel Order Dine In", checked: false },
      { name: "Cancel Item Dine In", checked: false },
      { name: "Substitute Item Dine In", checked: false },
      { name: "Refund Item Dine In", checked: false },
      { name: "View Delivery Orders", checked: false },
      { name: "Add Delivery Orders", checked: false },
      { name: "Edit Delivery Orders", checked: false },
      { name: "Change Delivery Order Status", checked: false },
      { name: "Cancel Order Delivery", checked: false },
      { name: "Cancel Item Delivery", checked: false },
      { name: "Substitute Item Delivery", checked: false },
      { name: "Refund Item Delivery", checked: false },
    ],
  },
  {
    name: "Seating",
    data: [
      { name: "View Pending Request", checked: false },
      { name: "Add Pending Request", checked: false },
      { name: "Edit Pending Request", checked: false },
      { name: "Change Pending Request Status", checked: false },
      { name: "View Seating Requests", checked: false },
      { name: "Add Seating Request", checked: false },
      { name: "Edit Seating Request", checked: false },
      { name: "Change Seating Request Status", checked: false },
      { name: "Seating Assign Table", checked: false },
      { name: "View Reservation Request", checked: false },
      { name: "Add Reservation Request", checked: false },
      { name: "Edit Reservation Request", checked: false },
      { name: "Change Reservation Request Status", checked: false },
      { name: "Reservation Assign Table", checked: false },
      { name: "Set Wait Time", checked: false },
      { name: "Edit Wait Time", checked: false },
      { name: "View History Request", checked: false },
      { name: "Add Diner", checked: false },
      { name: "Edit Diner", checked: false },
    ],
  },
  {
    name: "Event Seating Request Management",
    data: [
      { name: "View Pending Request", checked: false },
      { name: "Add Pending Guest", checked: false },
      { name: "Edit Pending Guest", checked: false },
      { name: "Change Pending Request Status", checked: false },
      { name: "Assign Table", checked: false },
      { name: "View RSVP Request", checked: false },
      { name: "Add RSVP Guest", checked: false },
      { name: "Edit RSVP Guest", checked: false },
      { name: "Change RSVP Request Status", checked: false },
      { name: "RSVP Assign Table", checked: false },
      { name: "Edit Wait Time RSVP", checked: false },
      { name: "View Ticket Book Request", checked: false },
      { name: "Add Ticket Book Guest", checked: false },
      { name: "Edit Ticket Book Guest", checked: false },
      { name: "Change Ticket Book Request Status", checked: false },
      { name: "Ticket Book Assign Table", checked: false },
      { name: "Edit Wait Time Ticket Book", checked: false },
      { name: "View History Request", checked: false },
      { name: "Add Guest", checked: false },
      { name: "Edit Guest", checked: false },
      { name: "View All Request", checked: false },
      { name: "Add All Guest", checked: false },
      { name: "Edit All Guest", checked: false },
      { name: "Cancel Ticket", checked: false },
      { name: "Refund Ticket", checked: false },
    ],
  },
  {
    name: "Item Management",
    data: [
      { name: "View Item Availability", checked: false },
      { name: "Add Item Availability", checked: false },
      { name: "Edit Item Availability", checked: false },
      { name: "Delete Item Availability", checked: false },
      { name: "Active Item Availability Status", checked: false },
      { name: "Inactivate Item Availability Status", checked: false },
      { name: "View Category", checked: false },
      { name: "Add Category", checked: false },
      { name: "Edit Category", checked: false },
      { name: "Delete Category", checked: false },
      { name: "Active Category Status", checked: false },
      { name: "Inactive Category Status", checked: false },
      { name: "Change Price", checked: false },
    ],
  },
  {
    name: "Users Management",
    data: [
      { name: "View User Management", checked: false },
      { name: "Add User Management", checked: false },
      { name: "Edit User Management", checked: false },
      { name: "Delete User Management", checked: false },
      { name: "Active User Management Status", checked: false },
      { name: "Inativate User Management Status", checked: false },
      { name: "Block User", checked: false },
      { name: "Reset User", checked: false },
      { name: "Flag User", checked: false },
    ],
  },
];

// const vendorPermission = {
//   staffManagement: {
//     staff_user_create: { type: Boolean, default: false },
//     staff_user_edit: { type: Boolean, default: false },
//     staff_user_view: { type: Boolean, default: false },
//     staff_user_delete: { type: Boolean, default: false },
//     staff_user_block: { type: Boolean, default: false },
//     staff_user_reset_password: { type: Boolean, default: false },
//     staff_user_flag: { type: Boolean, default: false },
//   },
//   offerManagement: {
//     add_offline_offer: { type: Boolean, default: false },
//     edit_offline_offer: { type: Boolean, default: false },
//     delete_offline_offer: { type: Boolean, default: false },
//     view_offline_offer: { type: Boolean, default: false },
//     active_offline_offer: { type: Boolean, default: false },
//     inactive_offline_offer: { type: Boolean, default: false },
//     add_online_offer: { type: Boolean, default: false },
//     edit_online_offer: { type: Boolean, default: false },
//     delete_online_offer: { type: Boolean, default: false },
//     view_online_offer: { type: Boolean, default: false },
//     active_online_offer: { type: Boolean, default: false },
//     inactive_online_offer: { type: Boolean, default: false }
//   },
//   eventManagement: {
//     add_offline_event: { type: Boolean, default: false },
//     edit_offline_event: { type: Boolean, default: false },
//     delete_offline_event: { type: Boolean, default: false },
//     view_offline_event: { type: Boolean, default: false },
//     active_offline_event: { type: Boolean, default: false },
//     inactive_offline_event: { type: Boolean, default: false },
//     view_offline_event_dashboard: { type: Boolean, default: false },
//     add_online_event: { type: Boolean, default: false },
//     edit_online_event: { type: Boolean, default: false },
//     delete_online_event: { type: Boolean, default: false },
//     view_online_event: { type: Boolean, default: false },
//     active_online_event: { type: Boolean, default: false },
//     inactive_online_event: { type: Boolean, default: false },
//     view_online_event_dashboard: { type: Boolean, default: false },
//     assign_seating_area: { type: Boolean, default: false }
//   },
//   orderManagement: {
//     view_pending_order: { type: Boolean, default: false },
//     add_pending_order: { type: Boolean, default: false },
//     edit_pending_order: { type: Boolean, default: false },
//     change_pending_order_status: { type: Boolean, default: false },
//     cancel_order: { type: Boolean, default: false },
//     cancel_item: { type: Boolean, default: false },
//     substitute_item: { type: Boolean, default: false },
//     refund_item: { type: Boolean, default: false },
//     view_all_order: { type: Boolean, default: false },
//     edit_all_order: { type: Boolean, default: false },
//     add_all_order: { type: Boolean, default: false },
//     change_all_order_status: { type: Boolean, default: false },
//     view_takeaway_order: { type: Boolean, default: false },
//     edit_takeaway_order: { type: Boolean, default: false },
//     change_takeaway_order_status: { type: Boolean, default: false },
//     cancel_order_takeaway: { type: Boolean, default: false },
//     cancel_item_takeaway: { type: Boolean, default: false },
//     substitute_item_takeaway: { type: Boolean, default: false },
//     refund_item_takeaway: { type: Boolean, default: false },
//     view_curbside_order: { type: Boolean, default: false },
//     add_curbside_order: { type: Boolean, default: false },
//     edit_curbside_order: { type: Boolean, default: false },
//     change_curbside_order_status: { type: Boolean, default: false },
//     cancel_order_curbside: { type: Boolean, default: false },
//     cancel_item_curbside: { type: Boolean, default: false },
//     substitute_item_curbside: { type: Boolean, default: false },
//     refund_item_curbside: { type: Boolean, default: false },
//     view_skip_the_line_order: { type: Boolean, default: false },
//     add_skip_the_line_order: { type: Boolean, default: false },
//     edit_skip_the_line_order: { type: Boolean, default: false },
//     change_skip_the_line_order_status: { type: Boolean, default: false },
//     cancel_order_skip_the_line: { type: Boolean, default: false },
//     cancel_item_skip_the_line: { type: Boolean, default: false },
//     substitute_item_skip_the_line: { type: Boolean, default: false },
//     refund_item_skip_the_line: { type: Boolean, default: false },
//     view_dine_in_order: { type: Boolean, default: false },
//     add_dine_in_order: { type: Boolean, default: false },
//     edit_dine_in_order: { type: Boolean, default: false },
//     change_dine_in_order_status: { type: Boolean, default: false },
//     cancel_order_dine_in: { type: Boolean, default: false },
//     cancel_item_dine_in: { type: Boolean, default: false },
//     substitute_item_dine_in: { type: Boolean, default: false },
//     refund_item_dine_in: { type: Boolean, default: false },
//     view_delivery_order: { type: Boolean, default: false },
//     add_delivery_order: { type: Boolean, default: false },
//     edit_delivery_order: { type: Boolean, default: false },
//     change_delivery_order_status: { type: Boolean, default: false },
//     cancel_order_delivery: { type: Boolean, default: false },
//     cancel_item_delivery: { type: Boolean, default: false },
//     substitute_item_delivery: { type: Boolean, default: false },
//     refund_item_delivery: { type: Boolean, default: false },
//   },
//   seatingManagement: {
//     view_pending_request: { type: Boolean, default: false },
//     add_pending_request: { type: Boolean, default: false },
//     edit_pending_request: { type: Boolean, default: false },
//     change_pending_request_status: { type: Boolean, default: false },
//     view_seating_request: { type: Boolean, default: false },
//     add_seating_request: { type: Boolean, default: false },
//     edit_seating_request: { type: Boolean, default: false },
//     change_seating_request_status: { type: Boolean, default: false },
//     seating_assign_table: { type: Boolean, default: false },
//     view_reservation_request: { type: Boolean, default: false },
//     add_reservation_request: { type: Boolean, default: false },
//     edit_reservation_request: { type: Boolean, default: false },
//     change_reservation_request_status: { type: Boolean, default: false },
//     reservation_assign_table: { type: Boolean, default: false },
//     set_wait_time: { type: Boolean, default: false },
//     edit_wait_time: { type: Boolean, default: false },
//     view_history_request: { type: Boolean, default: false },
//     add_diner: { type: Boolean, default: false },
//     edit_diner: { type: Boolean, default: false }

//   },
//   event_seating_request_management: {
//     view_pending_request: { type: Boolean, default: false },
//     add_pending_guest: { type: Boolean, default: false },
//     edit_pending_guest: { type: Boolean, default: false },
//     change_pending_request_status: { type: Boolean, default: false },
//     assign_table: { type: Boolean, default: false },
//     view_RSVP_request: { type: Boolean, default: false },
//     add_RSVP_guest: { type: Boolean, default: false },
//     edit_RSVP_guest: { type: Boolean, default: false },
//     change_RSVP_request_status: { type: Boolean, default: false },
//     RSVP_assign_table: { type: Boolean, default: false },
//     edit_wait_time_RSVP: { type: Boolean, default: false },
//     view_ticket_book_request: { type: Boolean, default: false },
//     add_ticket_book_guest: { type: Boolean, default: false },
//     edit_ticket_book_guest: { type: Boolean, default: false },
//     change_ticket_book_request_status: { type: Boolean, default: false },
//     ticket_book_assign_table: { type: Boolean, default: false },
//     edit_wait_time_ticket_book: { type: Boolean, default: false },
//     view_history_request: { type: Boolean, default: false },
//     add_guest: { type: Boolean, default: false },
//     edit_guest: { type: Boolean, default: false },
//     view_all_request: { type: Boolean, default: false },
//     add_all_guest: { type: Boolean, default: false },
//     edit_all_guest: { type: Boolean, default: false },
//     cancel_ticket: { type: Boolean, default: false },
//     refund_ticket: { type: Boolean, default: false }
//   },
//   itemManagement: {
//     view_item_availability: { type: Boolean, default: false },
//     add_item_availability: { type: Boolean, default: false },
//     edit_item_availability: { type: Boolean, default: false },
//     delete_item_availability: { type: Boolean, default: false },
//     active_item_availability_status: { type: Boolean, default: false },
//     inactivate_item_availability_status: { type: Boolean, default: false },
//     view_category: { type: Boolean, default: false },
//     add_category: { type: Boolean, default: false },
//     edit_category: { type: Boolean, default: false },
//     delete_categoty: { type: Boolean, default: false },
//     active_category_status: { type: Boolean, default: false },
//     inactive_categoty_status: { type: Boolean, default: false },
//     change_price: { type: Boolean, default: false },
//   },
//   user_management: {
//     view_user_management: { type: Boolean, default: false },
//     add_user_management: { type: Boolean, default: false },
//     edit_user_management: { type: Boolean, default: false },
//     delete_user_management: { type: Boolean, default: false },
//     active_user_management_status: { type: Boolean, default: false },
//     inactivate_user_management_status: { type: Boolean, default: false },
//     block_user: { type: Boolean, default: false },
//     reset_user: { type: Boolean, default: false },
//     flag_user: { type: Boolean, default: false }
//   }
// },

const AddRole = (props) => {
  const [state, setState] = React.useState(false);
  const [data, setData] = useState({ roleRemove: false });
  const [errors, setErrors] = useState({});

  const history = useHistory();

  const addRoleFun = (e) => {
    e.preventDefault();
    // vendor_create_role
    if (!data.role_name) {
      setErrors({ role_name: "Please enter a role name" });
    } else if (!data.role_desc) {
      setErrors({ role_desc: "Please enter a role description." });
    } else if (!("roleRemove" in data)) {
      setErrors({ roleRemove: "Please select an option." });
    } else {
      const token = props.auth.user.accessToken;
      const formData = {
        restaurant_id: props.restaurant_id,
        role_name: data.role_name,
        description: data.role_desc,
        isDefaultRole: data.role_default,
        isRemovable: data.roleRemove,
      };
      // console.log(formData);
      props.vendor_create_role(token, formData, () => {
        Alert.success(`<h4>Role added successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        history.push("/rolemanagement");
      });
    }
  };

  const onChange = (e) => {
    setErrors({});
    setData({ ...data, [e.target.name]: e.target.value });
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <Media query="(min-width: 992px)">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={2} />
            </div>
          </Media>

          <div className="super-admin-right-side-panel main-seating-dashboard-body">
            <div className="super-admin-inside-right-side-panel">
              <RightSideNavigation />

              {state ? (
                <div>
                  <div className="d-flex justify-content-between align-items-center pt-4 pb-4">
                    <div className="f24_700_HelveticaNeue">Permissions</div>
                  </div>
                  <Row>
                    <Col md={3}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel id="select-outlined-label">
                          Position
                        </InputLabel>
                        <Select
                          labelId="select-outlined-label"
                          id="select-outlined"
                          disabled
                          value={data.role_name}
                          label="Position"
                        >
                          <MenuItem value={data.role_name}>
                            {data.role_name}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Col>
                  </Row>
                  <div className="f16-500 mt-4">Role Description</div>
                  <div className="f12-400">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore
                  </div>
                  <Container
                    fluid
                    style={{ boxShadow: "0px 3px 11px #00000017" }}
                  >
                    <Row
                      style={{ backgroundColor: "#FFF2D5" }}
                      className="p-3 mt-4 f12-700"
                    >
                      <Col xs={8}>List of Permissions</Col>
                      <Col xs={4} align="center">
                        Select
                      </Col>
                    </Row>
                  </Container>

                  {staffManagementData.map((data, index) => {
                    return (
                      <>
                        <Row
                          style={{ backgroundColor: "#FFFFFF" }}
                          className={`p-3 f14-700 mr-0 ml-0 mt-4`}
                        >
                          <Col xs={12}>{data.name}</Col>
                        </Row>
                        <div className="mt-4">
                          {data.data.map((data, index) => {
                            return (
                              <Row className="f12-700 ml-0  mr-0">
                                <Col
                                  xs={7}
                                  className="white_background p-3 "
                                  style={{
                                    borderRadius: "5px",
                                    border: "0.5px solid #CCCCCC",
                                  }}
                                >
                                  {data.name}
                                </Col>
                                <Col xs={1}></Col>
                                <Col
                                  xs={4}
                                  className="white_background p-3"
                                  align="center"
                                  style={{
                                    borderRadius: "5px",
                                    border: "0.5px solid #CCCCCC",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    name="staff[]"
                                    value={`{${data.name
                                      .toLowerCase()
                                      .split(" ")
                                      .join("_")}}`}
                                    onChange={(value) => {
                                      console.log(value.target.value);
                                    }}
                                  />
                                </Col>
                              </Row>
                            );
                          })}
                        </div>
                      </>
                    );
                  })}
                </div>
              ) : (
                <>
                  <div className="d-flex justify-content-between align-items-center pt-4 pb-4">
                    <div className="f24_700_HelveticaNeue">Add Role</div>
                  </div>
                  <Form className="row">
                    <Col lg="6">
                      <NewInputText
                        labelText="Role Name"
                        extraClass="mb-4 w-100"
                        name="role_name"
                        value={data.role_name}
                        onChange={onChange}
                        errorTrue={errors.role_name}
                      />
                      <div className="mb-2" style={{ color: "red" }}>
                        {errors.role_name}
                      </div>
                      <NewInputText
                        labelText="Role Description"
                        extraClass="mb-3 w-100"
                        multiline={true}
                        rows="5"
                        name="role_desc"
                        value={data.role_desc}
                        onChange={onChange}
                        errorTrue={errors.role_desc}
                      />
                      <div className="mb-2" style={{ color: "red" }}>
                        {errors.role_desc}
                      </div>
                      <div className="d-flex align-items-center pb-5">
                        <Form.Check
                          label="1"
                          inline
                          className="enCheckBoxOnly"
                          name="role_default"
                          checked={data.role_default}
                          onChange={() => {
                            setData({
                              ...data,
                              role_default: !data.role_default,
                            });
                          }}
                          errorTrue={errors.role_default}
                        />
                        <div className="f12-500">Set As Default Role</div>
                      </div>
                      <div className="f14-700 mb-4">Role Removable?</div>
                      <div className="checkbox-bank-account justify-content-start">
                        <label className="enRadioWithText small mr-3">
                          <span className="f14-500">Yes</span>
                          <input
                            type="radio"
                            name="roleRemove"
                            checked={data.roleRemove}
                            onChange={() => {
                              setData({ ...data, roleRemove: true });
                            }}
                          />
                          <span className="checkmark"></span>
                        </label>
                        <label className="enRadioWithText small f18-500">
                          <span className="f14-500">No</span>
                          <input
                            type="radio"
                            name="roleRemove"
                            checked={!data.roleRemove}
                            onChange={() => {
                              setData({ ...data, roleRemove: false });
                            }}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                      <div className="mb-2" style={{ color: "red" }}>
                        {errors.roleRemove}
                      </div>
                    </Col>
                  </Form>
                </>
              )}
              <div className="d-flex align-items-center py-4">
                <Button
                  variant="outline-secondary"
                  className="btn150px btn-lg mr-4 px-5"
                  onClick={() => {
                    history.push("/rolemanagement");
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  onClick={(e) => {
                    if (state) {
                      addRoleFun(e);
                    } else {
                      setState(true);
                    }
                  }}
                  className="btn150px btn-lg px-5"
                >
                  Add
                </Button>
              </div>
            </div>
          </div>
          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
        </div>
      </div>
    </React.Fragment>
  );
};

AddRole.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  restaurant_id: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  restaurant_id: state.onboarding.restaurantDetails._id,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  vendor_create_role,
})(withRouter(AddRole));
